import React from 'react';
import styled from 'styled-components';

type HeaderOneComponentProps = {
  children: React.ReactNode
  className?: string
}

const HeaderOneStyle = styled.h1`
  color: #383432;
  font-size: 30px;
  font-weight: bold;
  margin: 0;

  @media (max-width: 767px) {
    font-size: 28px;
  }
`;

const HeaderOne: React.FC<HeaderOneComponentProps> = ({ children, className }) => {
  return (
    <HeaderOneStyle className={className}>
      { children }
    </HeaderOneStyle>
  );
};

export default HeaderOne;
